import type { ApiIncidentInputDto } from '@portals/shared/admin/ApiIncidentDto';

import { request } from '@/request';

export function saveIncident(data: ApiIncidentInputDto): Promise<void> {
  return request('/api-incidents', 'post', data);
}
